export const toggleSupplierInlineFormShared = ({
  state,
  canOpenSupplierInlineForm,
  requiresClassCategoryMessage,
}) => {
  if (!canOpenSupplierInlineForm) {
    state.$toast?.error(requiresClassCategoryMessage);
    return;
  }

  state.showSupplierInlineForm = !state.showSupplierInlineForm;
  if (!state.showSupplierInlineForm) {
    state.newSupplierName = '';
  }
};

export const cancelSupplierInlineFormShared = (state) => {
  state.showSupplierInlineForm = false;
  state.newSupplierName = '';
};

export const clearSupplierContributorsShared = ({
  state,
  form,
  options,
}) => {
  state.supplierContributorsRequestToken += 1;
  state.supplierContributorsLoading = false;
  form.supplierContributor = null;
  options.supplierContributors = [];
};

export const loadSupplierContributorsShared = async ({
  state,
  form,
  options,
  supplierOption,
  toPositiveOptionId,
  suppliersService,
  extractCollection,
  normalizeContributorOptions,
}) => {
  const supplierId = toPositiveOptionId(supplierOption);

  if (supplierId <= 0) {
    clearSupplierContributorsShared({ state, form, options });
    return;
  }

  const requestToken = state.supplierContributorsRequestToken + 1;
  state.supplierContributorsRequestToken = requestToken;
  state.supplierContributorsLoading = true;
  form.supplierContributor = null;
  options.supplierContributors = [];

  try {
    const response = await suppliersService.contributorsIndex(
      supplierId,
      { skipLoading: true }
    );

    if (requestToken !== state.supplierContributorsRequestToken) {
      return;
    }

    const contributorOptions = normalizeContributorOptions(extractCollection(response));
    options.supplierContributors = contributorOptions;

    const defaultOption = contributorOptions.find((option) => Number(option?.meta?.default || 0) === 1)
      || contributorOptions[0]
      || null;
    form.supplierContributor = defaultOption;
  } catch (error) {
    if (requestToken === state.supplierContributorsRequestToken) {
      form.supplierContributor = null;
      options.supplierContributors = [];
    }
  } finally {
    if (requestToken === state.supplierContributorsRequestToken) {
      state.supplierContributorsLoading = false;
    }
  }
};

export const saveSupplierInlineShared = async ({
  state,
  form,
  options,
  text,
  toPositiveOptionId,
  suppliersService,
  extractPayload,
  buildCreatedSupplierOption,
}) => {
  const name = String(state.newSupplierName || '').trim();
  const classId = toPositiveOptionId(form?.expenseClass);
  const categoryId = toPositiveOptionId(form?.expenseCategory);

  if (name === '' || state.creatingSupplier) {
    return;
  }

  if (classId <= 0 || categoryId <= 0) {
    state.$toast?.error(text.modal.supplierInline.requiresClassCategory);
    return;
  }

  state.creatingSupplier = true;

  try {
    const response = await suppliersService.store({
      name,
      class_id: classId,
      category_id: categoryId,
    });

    const supplier = extractPayload(response);
    const createdOption = buildCreatedSupplierOption({
      supplier,
      fallbackName: name,
      classId,
      categoryId,
      classLabel: form?.expenseClass?.label,
      categoryLabel: form?.expenseCategory?.label,
    });

    if (!Array.isArray(options.suppliers)) {
      options.suppliers = [];
    }

    options.suppliers = [...options.suppliers, createdOption]
      .sort((left, right) => String(left?.label || '').localeCompare(String(right?.label || ''), 'es'));
    form.supplier = createdOption;
    cancelSupplierInlineFormShared(state);
  } catch (error) {
    const message = error?.response?.data?.message || text.modal.supplierInline.createError;
    state.$toast?.error(message);
  } finally {
    state.creatingSupplier = false;
  }
};
